import { Partnership } from 'components/main-page/partnership/Partnership'
import { useLocation, useSearchParams } from 'react-router-dom'
import { downloadFile, getAllQueryParams, setQueryParams } from 'utils/utils'
import { INITIAL_DATA_FILTER } from 'configs/main-page/configTablePartnership'
import { useEffect, useState } from 'react'
import { useFetch } from 'services/useFetch'
import { API_PARTNERSHIP } from 'services/apiPartnership'
import { Alert } from 'avo-ui'
import moment from 'moment'

const INIT_STATUS = [
    {
        label: 'Waiting Review',
        value: 'waiting-review',
    },
    {
        label: 'On Review',
        value: 'on-review',
    },
    {
        label: 'Completed',
        value: 'completed',
    },
]

export const PartnershipContainer = () => {
    const location = useLocation()
    const [searchParams, setSearchParams] = useSearchParams()
    const query = searchParams.size > 0 ? getAllQueryParams(searchParams) : INITIAL_DATA_FILTER
    const [selectedIds, setSelectedIds] = useState([])
    const [selectedStatus, setSelectedStatus] = useState(INIT_STATUS[0])
    const [attachments, setAttachments] = useState({})
    const { fetching: getPartnershipList, data: partnershipList, isLoading } = useFetch(API_PARTNERSHIP.LIST)
    const { fetching: updateStatus, isLoading: isUpdating } = useFetch(API_PARTNERSHIP.UPDATE_STATUS)
    const { fetching: exportBrand, isLoading: isExporting } = useFetch(API_PARTNERSHIP.EXPORT)
    const [modal, setModal] = useState({
        export: false,
        confirm: false,
        attachments: false,
    })

    useEffect(() => {
        fetchPartnershipList()
    }, [location?.search])

    const setShowModal = (item) => {
        setModal({ ...modal, ...item })
    }

    const setShowAlert = (message, itemModal) => {
        setShowModal(itemModal)
        return Alert({
            icon: 'success',
            title: 'Success',
            message,
        })
    }

    const onChangeQuery = (queryParams) => {
        const params = setQueryParams({ ...query, ...queryParams })
        setSearchParams(params, { replace: true })
    }

    const fetchPartnershipList = (item = { ...query }) => {
        getPartnershipList(item)
    }

    const onChangeStatus = (item) => {
        setSelectedStatus(item?.value)
    }

    const onExport = () => {
        const { page, limit, ...queryRest } = query
        const payload = { ...queryRest, partnership_ids: selectedIds }
        exportBrand(payload, '', {}, 'blob').then((response) => {
            downloadFile(null, response, `Partnership-Export-${moment().format('DD-MM-YYYY')}.xlsx`)
            setShowAlert('Partnership Exported !', { export: false })
        })
    }

    const onConfirm = () => {
        const payload = {
            status: selectedStatus?.value,
            ids: selectedIds,
        }
        updateStatus(payload).then(() => {
            setShowAlert('Partnership Status Updated !', { confirm: false })
            fetchPartnershipList()
        })
    }

    const onSelectItemHandler = (item) => {
        const ids = item?.map((i) => i?.id)
        setSelectedIds(ids)
    }

    const onClickItemHandler = (value) => {
        setAttachments(value)
        setShowModal({ attachments: true })
    }

    const getUrl = (url) => {
        let newUrl = url
        const regexCheckUrl = [/^www/, /^https/]
        if (regexCheckUrl[0]?.test(url)) {
            newUrl = url?.replace('www.', 'https://')
        } else if (!regexCheckUrl[1]?.test(url)) {
            newUrl = `https://${url}`
        }

        return newUrl
    }

    const props = {
        dataList: partnershipList?.data,
        modal,
        setShowModal,
        query,
        onChangeQuery,
        selectedIds,
        statusOptions: INIT_STATUS,
        selectedStatus,
        attachments,
        onChangeStatus,
        onExport,
        onConfirm,
        onSelectItemHandler,
        onClickItemHandler,
        getUrl,
        isLoading,
        isUpdating,
        isExporting,
    }

    return <Partnership {...props} />
}
